<!-- Agent Info Popup - Modal displaying agent details -->
<div 
  class="popup-overlay" 
  *ngIf="isVisible && agent"
  tabindex="-1"
  (click)="onBackdropClick($event)"
  (keydown)="onOverlayKeydown($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="agent.name + ' details'">

  <div class="popup-modal">
    <!-- Fixed header: close, icon, name, Use, Make default -->
    <div class="popup-modal-header">
      <button 
        class="close-btn"
        (click)="close()"
        type="button"
        aria-label="Close popup">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div class="popup-header">
        <img 
          [src]="iconSrc" 
          [alt]="agent.name + ' icon'"
          class="agent-icon"
          (error)="agent.icon = ''">
        <h2 class="agent-name">{{ (agent.name ||"")| translate }}</h2>
      </div>

      <div class="action-row">
        <button 
          class="use-btn"
          (click)="onUseClick()"
          type="button">
          {{'ABOUT_AGENT_USE_BUTTON'| translate}}
        </button>
        <button 
          class="make-default-link"
          (click)="onMakeDefaultClick()"
          type="button">
          <span class="make-default-pin" aria-hidden="true"></span>
          {{'ABOUT_AGENT_MAKE_DEFAULT'| translate}}
        </button>
      </div>
    </div>

    <!-- Scrollable body: About, Version, Features -->
    <div class="popup-modal-body">
    <!-- About Section -->
    <div class="popup-section" *ngIf="aboutParagraphs.length > 0">
      <h3 class="section-title">{{'ABOUT_AGENT_ABOUT_SECTION_HEADING'| translate}}</h3>
      <div class="section-content about-content">
        <p *ngFor="let paragraph of aboutParagraphs">{{ (paragraph||"")| translate }}</p>
      </div>
    </div>

    <!-- Version Section -->
    <div class="popup-section" *ngIf="agent.version || (agent.versionNotes && agent.versionNotes.length > 0)">
      <h3 class="section-title" *ngIf="agent.version">{{'ABOUT_AGENT_VERSION_HEADING'| translate}}  {{ agent.version }}</h3>
      <div class="section-content" *ngIf="agent.versionNotes && agent.versionNotes.length > 0">
        <!-- <p class="version-intro">{{ agent.versionNotes[0] }}</p> -->
        <ul class="bullet-list">
          <li *ngFor="let note of agent.versionNotes">{{ (note || "")| translate }}</li>
        </ul>
      </div>
    </div>

    <!-- Features Section -->
    <div class="popup-section" *ngIf="agent.features && agent.features.length > 0">
      <h3 class="section-title">{{'ABOUT_AGENT_FEATURE_HEADING'| translate}}</h3>
      <div class="section-content">
        <!-- <p class="version-intro">{{ agent.features[0] }}</p> -->
        <ul class="bullet-list">
          <li *ngFor="let feature of agent.features">{{ (feature || "")| translate }}</li>
        </ul>
      </div>
    </div>

    </div>
  </div>
</div>
